/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListHiddenMcpServersSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListHiddenMcpServersRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListHiddenMcpServersSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListHiddenMcpServersSecurity$outboundSchema: z.ZodMiniType<
  ListHiddenMcpServersSecurity$Outbound,
  ListHiddenMcpServersSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listHiddenMcpServersSecurityToJSON(
  listHiddenMcpServersSecurity: ListHiddenMcpServersSecurity,
): string {
  return JSON.stringify(
    ListHiddenMcpServersSecurity$outboundSchema.parse(
      listHiddenMcpServersSecurity,
    ),
  );
}

/** @internal */
export type ListHiddenMcpServersRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListHiddenMcpServersRequest$outboundSchema: z.ZodMiniType<
  ListHiddenMcpServersRequest$Outbound,
  ListHiddenMcpServersRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listHiddenMcpServersRequestToJSON(
  listHiddenMcpServersRequest: ListHiddenMcpServersRequest,
): string {
  return JSON.stringify(
    ListHiddenMcpServersRequest$outboundSchema.parse(
      listHiddenMcpServersRequest,
    ),
  );
}
